export const moduleSlug = 'dashboard'
export const moduleAuth = 'Dashboard';

export const children = [
  {
    path: "",
    component: () => import("./pages/MainDashboard.vue"),
    meta: {
      title: "Dashboard",
      linkTitle: "Dashboard",
      linkIcon: "home",
      showInNav: true,
      permission: "Dashboard.Dashboard",
    },
  },
  {
    path: "store-summary",
    component: () => import("./pages/StoreSummary.vue"),
    meta: {
      title: "Store Summary",
      linkTitle: "Store Summary",
      linkIcon: "file-text",
      showInNav: true,
      permission: "Transactions.StoreSummaryReport",
    },
  },
  {
    path: "store-status",
    component: () => import("./pages/StoreStatus.vue"),
    meta: {
      title: "Store Status",
      linkTitle: "Store Status",
      linkIcon: "file-text",
      showInNav: true,
      permission: "Dashboard.StoreStatus",
    },
  },
  {
    path: "reports",
    meta: {
      title: "Other Report",
      linkTitle: "Other Report",
      linkIcon: "database",
      showInNav: true,
      excludeInRoute: true,
      menu: [
        {
          path: "transactions",
          title: "Transaction Reports",
          permission: "Transactions.TransactionReport",
        },
        {
          path: "products",
          title: "Product wise Sales Report",
          permission: "Transactions.ProductReport",
        },
        {
          path: "sales",
          title: "Sales Summary",
          permission: "Transactions.SalesSummaryReport",
        },
      ],
    },
  },
  {
    path: "products",
    component: () => import("./pages/ItemWiseSalesReport.vue"),
    meta: {
      title: "Product wise Sales Report",
      linkTitle: "Product wise Sales Report",
      linkIcon: "home",
      showInNav: false,
      permission: "Transactions.ProductReport",
    },
  },
  {
    path: "sales",
    component: () => import("./pages/SalesSummary.vue"),
    meta: {
      title: "Sales Summary",
      linkTitle: "Sales Summary",
      linkIcon: "bar-chart",
      showInNav: false,
      permission: "Transactions.SalesSummaryReport",
    },
  },

  {
    path: "transactions",
    component: () => import("./pages/Transactions.vue"),
    meta: {
      title: "Transaction Reports",
      linkTitle: "Transaction Reports",
      linkIcon: "database",
      showInNav: false,
      permission: "Transactions.TransactionReport",
    },
  },
  {
    path: 'config/settings',
    component: () => import('@/components/Configuration/Configurations.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Configurations',
      linkIcon: '',
      showInNav: false,
      brandFlag: 'enableConfigurations',
      permission: "Dashboard.Config.Settings",
    }
  },
    {
    path: 'config/report-triggers',
    component: () => import('./pages/TriggerReports.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Trigger Report',
      linkIcon: 'database',
      showInNav: false,
      permission: "Dashboard.Config.Triggers.Read"
    }
  },
  {
    path: 'config/report-triggers/create',
    component: () => import('./pages/ReportTriggerAddOrUpdate.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Trigger Report Create',
      linkIcon: '',
      showInNav: false,
      permission: "Dashboard.Config.Triggers.Read"
    }
  },
  {
    path: 'config/report-triggers/update/:id',
    component: () => import('./pages/ReportTriggerAddOrUpdate.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Trigger Report Update',
      linkIcon: '',
      showInNav: false,
      permission: "Dashboard.Config.Triggers.Read"
    }
  },
];

export const quickLinks = [
  {
    name: 'Settings',
    link: `/${moduleSlug}/config/settings`,
    new: true,
    brandFlag: 'enableConfigurations',
    permission: "Dashboard.Config.Settings",
  },
  {
    name: 'Report Triggers',
    link: `/${moduleSlug}/config/report-triggers`,
    new: true,
    permission: "Dashboard.Config.Triggers.Read",
  },
];
